module.exports = __webpack_public_path__ + "static/media/Pay.c57b223f.png";